module.exports = __webpack_public_path__ + "img/info.ea57db62.png";